module.exports = __webpack_public_path__ + "static/media/logo-part-4.c0c250d0.svg";